import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/distributors/$id` (без таба) → редирект на `/distributors/$id/overview`
 *  (PA-12, D17 §2.3). Layout-route `distributors.$id.tsx` несёт shell + TabBar,
 *  но без явно выбранного таба контент пустой — этот index-route обеспечивает
 *  дефолтное переход на «Обзор». */
export const Route = createFileRoute('/distributors/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/distributors/$id/overview',
      params: { id: params.id },
    })
  },
})
